import { createSlice } from "@reduxjs/toolkit";

// Mirrors the documents currently attached inside Visi. Visi owns the selection; this copy exists so
// the SharePoint sign-in thunk can persist it before the page unloads (VT-9434).
const initialState = {
  list: [],
};

const attachedDocumentsSlice = createSlice({
  name: "visiAttachedDocuments",
  initialState,
  reducers: {
    setAttachedDocuments: (state, action) => {
      state.list = action.payload;
    },
    clearAttachedDocuments: (state) => {
      state.list = [];
    },
  },
});

export const { setAttachedDocuments, clearAttachedDocuments } =
  attachedDocumentsSlice.actions;

export const selectAttachedDocuments = (state) =>
  state.visi.attachedDocuments.list;

export default attachedDocumentsSlice.reducer;
